import React, { useState } from "react";
import { HardHat } from "lucide-react";
import OccupationalSafetyContents from "./components/OccupationalSafetyContents";
import FullHeaderComponent from "../components/FullHeaderComponent";

const OccupationalSafetyPolicy = () => {
  const [searchTerm, setSearchTerm] = useState("");
  
  const handleSearch = (params) => {
    setSearchTerm(params?.keyword || "");
  };

  return (
    <div className="flex flex-col -mx-3 sm:-mx-4 md:-mx-6 -mt-3 sm:-mt-4 md:-mt-6">
      <FullHeaderComponent
        icon={HardHat}
        title="Occupational Safety, Health & Wellbeing Policy"
        subtitle="Hyvid Philippines · Owner: People & Culture · Review: Annually"
        hyvidScope="Applies to: All Hyvid Philippines employees"
        workArrangement="Remote / work-from-home"
        reviewTime="Annually"
        searchHandler={handleSearch}
      />
      <div>
        <OccupationalSafetyContents searchTerm={searchTerm}/>
      </div>
    </div>
  );
};

export default OccupationalSafetyPolicy;